import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const postLead = (email, source = "ebook") =>
  axios.post(`${API}/leads`, { email, source }).then((r) => r.data);

export const postContact = (payload) =>
  axios.post(`${API}/contact`, payload).then((r) => r.data);
